import React, { Component } from "react";
import ReactExport from "react-export-excel";

// eslint-disable-next-line react/prefer-stateless-function
class Download extends Component {

    render() {
        const { reports, element } = this.props;
        const { ExcelFile } = ReactExport;
        const { ExcelSheet } = ReactExport.ExcelFile;
        const { ExcelColumn } = ReactExport.ExcelFile;
        console.log(JSON.stringify(reports))
        return (
            <ExcelFile element={element}>
                <ExcelSheet data={reports} name="Reports">
                    <ExcelColumn label="Application Id" value="applicationId" />
                    <ExcelColumn label="Application Name" value="applicationName" />
                    <ExcelColumn label="Channel Id" value="channelId" />
                    <ExcelColumn label="Channel Code" value="channelCode" />
                    <ExcelColumn label="Total Transaction" value="totalTransaction" />
                    <ExcelColumn label="Success Rate" value="successRate" />
                    <ExcelColumn label="Fail Rate" value="failedRate" />
                </ExcelSheet>
                {
                    reports?.map((val) => {
                        return (
                            <ExcelSheet data={val?.data || []} name={`${val.channelCode} ${val.startDate} - ${val.endDate}`}>
                                <ExcelColumn label="Date" value="date" />
                                <ExcelColumn label="Request Success" value="requestSuccess" />
                                <ExcelColumn label="Request Failed" value="requestSuccess" />
                            </ExcelSheet>
                        )
                    })
                }
            </ExcelFile>
        );
    }
}

export default Download;